import { render, staticRenderFns } from "./important-documents.vue?vue&type=template&id=050e67e8"
import script from "./important-documents.vue?vue&type=script&lang=ts"
export * from "./important-documents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports